import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, FeatureFlag, FlagValue } from '@ra-state';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { selectFlags } from './feature-flags.selectors';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  flags$ = this.store$.select(selectFlags);

  getFlagValue$(flag: FeatureFlag): Observable<FlagValue> {
    return this.flags$.pipe(
      map((flags) => (flags ? flags[flag] : undefined)),
      distinctUntilChanged(),
    );
  }
}
